<ng-container *ngIf="isBrowser() && partner?.partnerid?.length > 0">
    <ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>
</ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="nohomefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-extra-wrapper-mobile">
        @if(!partner.filters?.hidePreisproPersonfilter) {
        <div class="tmp-section-wrapper-mobile">
            <clever-price [mode]="'home'"></clever-price>
        </div>
        }
        <div class="tmp-section-wrapper-mobile">
            @if(!partner.filters?.hideZwischenstoppsfilter) {
            <clever-direktflug [mode]="'home'" [partner]="partner"></clever-direktflug>
            }
            @if(!partner.filters?.hideTransferfilter) {
            <clever-transfer [mode]="'home'" [partner]="partner"></clever-transfer>
            }
        </div>
        <div class="tmp-section-wrapper-mobile">
            <@if(!partner.filters?.hideHinflugzeitfilter) { <clever-flightzeit [mode]="'home'" [title]="'Hinflugzeit'"
                [isHinflug]="true"></clever-flightzeit>
                }
                @if(!partner.filters?.hideRuckflugzeitfilter) {
                <clever-flightzeit [mode]="'home'" [title]="'Rückflugzeit'" [isHinflug]="false"></clever-flightzeit>
                }
        </div>
    </div>
    <div class="tmp-footer-mobile">
        <button class="mb1" (click)="resetAll()" matRipple>
            <span multilang>Alle Filter löschen</span>
        </button>
        <span multilang></span>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-extra-wrapper">
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hidePreisproPersonfilter) {
            <clever-price [mode]="'home'"></clever-price>
            }
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideZwischenstoppsfilter) {
            <clever-direktflug [mode]="'home'" [partner]="partner"></clever-direktflug>
            }
            <clever-travelclass [mode]="'home'"></clever-travelclass>
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideHinflugzeitfilter) {
            <clever-flightzeit [mode]="'home'" [title]="'Hinflugzeit'" [isHinflug]="true"></clever-flightzeit>
            }
            @if(!partner.filters?.hideRuckflugzeitfilter) {
            <clever-flightzeit [mode]="'home'" [title]="'Rückflugzeit'" [isHinflug]="false"></clever-flightzeit>
            }
        </div>
    </div>
    <div class="tmp-footer">
        <span multilang></span>
        <div class="tmp-flexy">
            <button class="tmp-reset-btn" (click)="resetAll()" matRipple>
                <span multilang>Alle Filter löschen</span>
            </button>
            <button class="tmp-close-btn" (click)="closeextras()" matRipple>
                <span multilang>Schließen</span>
                <mat-icon>arrow_drop_up</mat-icon>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="nohome-wrapper-desk">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #nohomemodeMobile>
    <div class="nohome-wrapper">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #myfilters>
    @if(!partner?.filters?.hideflexiblefilter) {
    <clever-flexibel [tourOperatorList]="tourOperatorList"></clever-flexibel>
    }
    @if(!partner?.filters?.hidePreisproPersonfilter) {
    <clever-price [mode]="'nohome'"></clever-price>
    }

    @if(!partner.filters?.hideZwischenstoppsfilter) {
    <clever-direktflug [mode]="'nohome'" [partner]="partner"></clever-direktflug>
    }
    <clever-travelclass [mode]="'nohome'"></clever-travelclass>

    <ng-container *ngIf="tmp_stat; else skloading">
        @if(!partner.filters?.hideVeranstalterfilter) {
        <clever-touroperator [mode]="'nohome'" [partner]="partner"
            [tourOperatorList]="tmp_stat.tourOperatorList"></clever-touroperator>
        }
        @if(!partner.filters?.hideFluggesellschaftenfilter) {
        <clever-flight-carrier-list [mode]="'nohome'" [flightCarrierList]="tmp_stat?.flightCarrierList">
        </clever-flight-carrier-list>
        }
    </ng-container>
    @if(!partner.filters?.hideHinflugzeitfilter) {
    <clever-flightzeit [mode]="'nohome'" [title]="'Hinflugzeit'" [isHinflug]="true"></clever-flightzeit>
    }
    @if(!partner.filters?.hideRuckflugzeitfilter) {
    <clever-flightzeit [mode]="'nohome'" [title]="'Rückflugzeit'" [isHinflug]="false"></clever-flightzeit>
    }
</ng-template>

<ng-template #skloading>
    <div style="width: 100%;display: flex;flex-direction: column;margin-bottom: 1rem;">
        <div class="skeleton" style="height: 20px;width: 200px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 150px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 100px;margin-top: .5rem;"></div>
    </div>
</ng-template>